import { statusOrderClass } from '@/utils/order/statusOrder'

export const updateMostRecentOrderClass = (
  orderStatusId: number,
  mostRecentOrderClass: { value: string }
) => {
  mostRecentOrderClass.value = statusOrderClass(orderStatusId)
}

/**
 * The status label is localized server-side and delivered on each order as
 * `order_status_name`. Pass it through directly; no id-based mapping here.
 */
export const updateMostRecentOrderText = (
  orderStatusName: string,
  mostRecentOrderText: { value: string }
) => {
  mostRecentOrderText.value = orderStatusName ?? ''
}
